import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;
  const pages = [];
  const push = (n) => pages.push(n);
  // Compact page numbers: first, current-1..current+1, last, with ellipsis
  push(1);
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) push('…');
  for (let i = start; i <= end; i++) push(i);
  if (end < totalPages - 1) push('…');
  if (totalPages > 1) push(totalPages);

  return (
    <nav aria-label="Pagination" data-testid="pagination" className="flex items-center justify-center gap-2 py-12">
      <button
        type="button"
        aria-label="Previous page"
        data-testid="pagination-prev"
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        className="h-10 w-10 inline-flex items-center justify-center border border-border hover:border-foreground disabled:opacity-30 disabled:cursor-not-allowed transition-colors duration-500"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      {pages.map((p, i) => (
        <button
          key={`${p}-${i}`}
          type="button"
          disabled={p === '…'}
          data-testid={p !== '…' ? `pagination-page-${p}` : undefined}
          onClick={() => p !== '…' && onPageChange(p)}
          className={`h-10 min-w-10 px-3 text-sm tabular border transition-colors duration-500 ${
            p === page
              ? 'bg-foreground text-background border-foreground'
              : p === '…'
              ? 'border-transparent cursor-default text-muted-foreground'
              : 'border-border hover:border-foreground'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        aria-label="Next page"
        data-testid="pagination-next"
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        className="h-10 w-10 inline-flex items-center justify-center border border-border hover:border-foreground disabled:opacity-30 disabled:cursor-not-allowed transition-colors duration-500"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </nav>
  );
}
